import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api } from '../../api.js';
import { useAuth } from '../../auth/AuthProvider.js';
import type { ConfigStatus } from '../../types/onboarding.js';

export function BusinessInfo() {
  const { activeOrgId } = useAuth();
  const nav = useNavigate();
  const { data } = useQuery({
    queryKey: ['config-status', activeOrgId],
    queryFn: () => api<ConfigStatus>(`/orgs/${activeOrgId}/config-status`),
    enabled: !!activeOrgId,
  });
  if (!data) return null;
  const o = data.organization;
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium">Información del negocio</h2>
      <p className="text-sm text-slate-600">
        Estos datos se establecieron al crear la organización.
      </p>
      <dl className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <dt className="text-slate-500">Nombre</dt>
          <dd>{o.name}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Slug</dt>
          <dd>{o.slug}</dd>
        </div>
        <div>
          <dt className="text-slate-500">País</dt>
          <dd>{o.countryCode}</dd>
        </div>
        <div>
          <dt className="text-slate-500">Moneda</dt>
          <dd>{o.baseCurrency}</dd>
        </div>
      </dl>
      <div className="flex justify-end gap-3 pt-4">
        <button
          type="button"
          onClick={() => nav('/app/onboarding/wizard/fiscal')}
          className="rounded bg-blue-600 px-4 py-2 text-white"
        >
          Siguiente →
        </button>
      </div>
    </div>
  );
}
